import React from 'react';
import ToggleButton from 'v2/common/ToggleButton/ToggleButton';

interface AssignToMeToggleProps {
  isChecked: boolean;
  isDisabled: boolean;
  onChange: () => void;
  show: boolean;
}

const AssignToMeToggle = ({
  isChecked,
  isDisabled,
  onChange,
  show,
}: AssignToMeToggleProps) => {
  if (!show) {
    return null;
  }
  return (
    <ToggleButton
      className="ml-3"
      checked={isChecked}
      onChange={() => onChange()}
      label="Assign to me"
      helpText="Let your team know that you are working on this request."
      ariaLabel="assignToMeBtn"
      disabled={isDisabled}
    />
  );
};

export default AssignToMeToggle;
